import { Button, Input, Modal, Table, message } from 'antd';
import { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { API } from '../../../http';
import { NEW_ENDPOINTS } from '../../../http/endpoints';
import { useSelector } from 'react-redux';
import { getUser } from '../../../store/selectors';

const DeductFee = ({ userId, loading, setLoading, fetchTransactions }) => {
  const [fees, setFees] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [amount, setAmount] = useState();
  const [description, setDescription] = useState('');

  const admin = useSelector(getUser);

  const columns = [
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      
      render: (value) => <Typography.Text>{value}</Typography.Text>
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) => <Typography.Text>{value} EUR</Typography.Text>
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 200,
      dataIndex: 'actions',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button type='primary' onClick={() => onDeduct(record.id)}>Deduct Fee</Button>
          <Button danger onClick={() => onDelete(record.id)}>Delete</Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchFees();
  }, []);

  const onDelete = async (id) => {
    setLoading(true);

    try {
      await API.post(NEW_ENDPOINTS.ADMIN.FEE.DELETE, { fee_id: id });
      await fetchFees();
    } catch (e) {
      message.error('Failed to delete fee');
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onDeduct = async (id) => {
    setLoading(true);

    try {
      await API.post(NEW_ENDPOINTS.ADMIN.FEE.DEDUCT, { fee_id: id, userId, admin_id: admin.id });
      await fetchTransactions(userId);
    } catch (e) {
      message.error('Failed to deduct fee');
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onCreate = async () => {
    setLoading(true);
    try {
      await API.post(NEW_ENDPOINTS.ADMIN.FEE.CREATE, { amount, description, admin_id: admin.id });
      await fetchFees();
      setModalOpen(false);
      setDescription('');
      setAmount(undefined);
    } catch (e) {
      message.error('Failed to create fee');
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchFees = async () => {
    const {
      data: { data }
    } = await API.get(NEW_ENDPOINTS.ADMIN.FEE.LIST);
    setFees(data);
  };

  return (
    <div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          loading={loading}
          style={{ marginBottom: '20px' }}
          type='primary'
          onClick={() => setModalOpen(true)}>
          Create Fee
        </Button>
      </div>

      <Table columns={columns} dataSource={fees} />

      <Modal
        title='Create Fee'
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={() => setModalOpen(false)}
        footer={null}>
        <div
          style={{
            marginTop: 20,
            marginBottom: 20,
            display: 'flex',
            gap: '10px',
            flexDirection: 'column'
          }}>
          <Typography.Text>Description</Typography.Text>
          <Input
            placeholder='Description'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div
          style={{
            marginBottom: 20,
            display: 'flex',
            gap: '10px',
            flexDirection: 'column'
          }}>
          <Typography.Text>Amount</Typography.Text>
          <Input
            placeholder='Amount'
            type='number'
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <Button
          loading={loading}
          disabled={!amount || !description || amount <= 0}
          style={{ marginBottom: '20px', width: '100%' }}
          type='primary'
          onClick={onCreate}>
          Create
        </Button>
      </Modal>
    </div>
  );
};

export default DeductFee;
